import React, { Component } from 'react';
import { get, post } from 'axios';
import { inject, observer } from 'mobx-react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';

class ModalInvoiceView extends Component {
    constructor(props){
        super(props);
        this.state = {
            selectedInvoice:null
        }
    }

    componentWillReceiveProps(nextProps){
        this.setState({
            selectedInvoice:nextProps.invoice
        });
    }

    componentDidMount(){
      console.log(this.props);
        this.setState({
            selectedInvoice:this.props.invoice
        });
    }

  render() {
      if (!this.state.selectedInvoice || !this.state.selectedInvoice.service_list) return <div className="alert alert-danger">Loading Invoice...</div>;
      const {selectedInvoice} = this.state;
      const {modalBackgroundClicked, isModal} = this.props;

    return (
    	<React.Fragment>
            <PerfectScrollbar>
            <div className="card">
                {isModal ?
                <React.Fragment>
                <header className="card-header">
                    <h4 className="card-title">#{selectedInvoice.id}: {selectedInvoice.description}</h4>
                    <button type="button" className="close" onClick={modalBackgroundClicked} aria-label="Close">
                      <span aria-hidden="true">×</span>
                    </button>
                </header>
                </React.Fragment>
                : null}
                <div className="card-body">
                    <p className="lead">{selectedInvoice.booking.full_name}<br/>{selectedInvoice.booking.date} @ {selectedInvoice.booking.ready_time}</p>
                    {selectedInvoice.is_published ? <p className="text-success">Invoice is <strong>PUBLISHED</strong> do not make changes as client may make payment.</p> : <p className="text-warning">Invoice has not been published.</p>}
                    <div className="card">
                        <h3 className="card-title">Services</h3>
                        <table className="table table-striped">
                            <tbody>
                {selectedInvoice.service_list.length === 0 ?
                    <tr><td>No Services</td></tr>
                    : selectedInvoice.service_list.map((service, index)=>
                    <tr key={index}>
                        <td style={{width: 70+'%'}}>{service.name}</td>
                        <td style={{width: 10+'%', textAlign:'center'}}>{service.quantity}</td>
                        <td style={{width: 20+'%', textAlign:'right'}}>${service.price}</td>
                    </tr>
                )}
                            </tbody>
                        </table>
                    </div>
                    <div className="card">
                        <h3 className="card-title">Line Items</h3>
                        <table className="table table-striped">
                            <tbody>
                {selectedInvoice.lineitem_list.map((lineitem, index)=>
                    <tr key={index}>
                        <td style={{width: 70+'%'}}>{lineitem.name}</td>
                        <td style={{width: 10+'%', textAlign:'center'}}>{lineitem.quantity}</td>
                        <td style={{width: 20+'%', textAlign:'right'}}>{lineitem.is_percentage ? <span>{lineitem.price}%</span> : <span>${lineitem.price}</span>}</td>
                    </tr>
                )}
                            </tbody>
                        </table>
                        <div className="card-footer">
                          <h4 className="text-right">Line Item Total: ${selectedInvoice.lineitem_total}</h4>
                        </div>
                        <div className="card-footer">
                          <h2 className="text-right">Grand Total: ${selectedInvoice.due_amount}</h2>
                        </div>
                    </div>
                </div>
                {isModal ?
                <React.Fragment>
                <footer className="card-footer">
                    <button type="button" className="btn btn-secondary pull-right" onClick={modalBackgroundClicked}>Close</button>
                </footer>
                </React.Fragment>
                : null}
            </div>
            </PerfectScrollbar>
        </React.Fragment>
    )
  }
}

export default ModalInvoiceView;



// WEBPACK FOOTER //
// ./src/components/business/ModalInvoiceView.js